import Crud from './crud'
var crud = new Crud('export-receipt', 'phiếu xuất kho');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        UID: 0,
        ReceiptType: 0,
        PriceOfPack: 0,
        VatRate: 0,
        ExportRate: 0,
        ImportRate: 0,
        TrusteeRate: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};